<template>
  <div>
    <!-- 顶部返回 -->
    <div class="back-icon" @click="goBack"><span class="arr"></span><span class="icon"></span></div>

    <!-- 顶部大区角色展示 -->
    <div class="back-icon back-icon--style" @click="changeZone">
      {{ (userZoneInfo && userZoneInfo.propsShowZoneRoleName) || "点击选择大区" }}

      <!-- 当用户是直接进入或者当前没有选中大区的时候，展示选区标签-->
      <span v-if="canChangeZone" class="arr"></span>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex"

export default {
  props: ["userZoneInfo", "canChangeZone", "isStraightLink", "currentItem"],

  methods: {
    ...mapActions(["reportUserAction"]),
    goBack() {
      if (this.isStraightLink) {
        this.$router.push({
          path: `/backpack/${this.currentItem.groupId}/biz/${this.currentItem.busId}`,
          query: {
            ...this.$route.query
          }
        })
      } else {
        this.$router.go(-1)
      }

      // this.reportUserAction({
      //   iformat: ""
      // })
    },

    changeZone() {
      // this.reportUserAction({
      //   iformat: ""
      // })

      if (!this.canChangeZone) {
        return
      }

      this.$emit("changeZone")
    }
  }
}
</script>
